// src/pages/Home/index.jsx
import React, { useState, useEffect } from 'react';
import { Layout, Typography, Pagination, Spin, Empty, Row, Col, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import AppHeader from '../../components/Header';
import AppFooter from '../../components/Footer';
import PostCard from '../../components/PostCard';
import { useBlog } from '../../context/BlogContext';
import './index.css';

const { Title } = Typography;

const Home = ({ loggedInUser, onLogout }) => {
  const { posts, loading: blogLoading } = useBlog();
  const [filteredPosts, setFilteredPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const pageSize = 4;

  // 处理搜索和过滤
  useEffect(() => {
    setLoading(true);
    // 模拟加载延迟
    const timer = setTimeout(() => {
      let result = [...posts];
      
      if (searchQuery) {
        result = result.filter(post => 
          post.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
          post.excerpt.toLowerCase().includes(searchQuery.toLowerCase()) ||
          (post.author?.username?.toLowerCase() || '').includes(searchQuery.toLowerCase())
        );
      }
      
      setFilteredPosts(result);
      setLoading(false);
    }, 300);
    
    return () => clearTimeout(timer);
  }, [posts, searchQuery]);

  const total = filteredPosts.length;
  const paginatedPosts = filteredPosts.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const handleSearch = (value) => {
    setSearchQuery(value);
    setCurrentPage(1);
  };

  return (
    <Layout className="blog-layout">
      <AppHeader loggedInUser={loggedInUser} onLogout={onLogout} />
      <div className="blog-content home-content">
        <div className="home-container">
          <Title level={2} className="home-title">
            最新文章
          </Title>
          
          {/* 搜索框 */}
          <div className="home-search">
            <Input
              placeholder="搜索文章..."
              prefix={<SearchOutlined />}
              onChange={(e) => handleSearch(e.target.value)}
              allowClear
              size="large"
            />
          </div>
          
          <Row gutter={24}>
            <Col xs={24} lg={16}>
              {loading || blogLoading ? (
                <div className="home-loading">
                  <Spin size="large" tip="加载中..." />
                </div>
              ) : paginatedPosts.length > 0 ? (
                <>
                  <div className="posts-list">
                    {paginatedPosts.map(post => (
                      <Link to={`/post/${post.id}`} key={post.id} style={{ textDecoration: 'none' }}>
                        <PostCard post={post} />
                      </Link>
                    ))}
                  </div>
                  
                  <Pagination
                    className="home-pagination"
                    current={currentPage}
                    pageSize={pageSize}
                    total={total}
                    onChange={(page) => setCurrentPage(page)}
                    showSizeChanger={false}
                    hideOnSinglePage={true}
                  />
                </>
              ) : (
                <Empty
                  description="没有找到相关文章"
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
              )}
            </Col>
            
            <Col xs={24} lg={8}>
              <div className="home-sidebar">
                {/* 侧边栏内容 */}
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <AppFooter />
    </Layout>
  );
};

export default Home;